import React, {
  useState,
  useContext,
  createContext,
  useCallback,
  useEffect,
  useMemo
} from "react";

const DateRangeContext = createContext();

export default function DateRangeProvider({ children }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth());

  const [from, setFrom] = useState(new Date(year, month, 1));
  const [to, setTo] = useState(new Date(year, month + 1, 0));

  const goToPreviousMonth = useCallback(() => {
    if (month === 0) {
      setMonth(11);
      setYear(year - 1);
      return;
    }

    setMonth(month - 1);
  }, [month, year]);

  const goToNextMonth = useCallback(() => {
    if (month === 11) {
      setMonth(0);
      setYear(year + 1);
      return;
    }

    setMonth(month + 1);
  }, [month, year]);

  const goToCurrentMonth = useCallback(() => {
    const currentDate = new Date();
    setMonth(currentDate.getMonth());
    setYear(currentDate.getFullYear());
  }, []);

  useEffect(() => {
    setFrom(new Date(year, month, 1));
    setTo(new Date(year, month + 1, 0));
  }, [month, year]);

  const isCurrentMonth = useMemo(() => {
    const currentDate = new Date();
    return currentDate.getFullYear() === year && currentDate.getMonth() === month;
  }, [month, year]);

  return (
    <DateRangeContext.Provider
      value={{
        year,
        month,
        to,
        from,
        goToPreviousMonth,
        goToNextMonth,
        goToCurrentMonth,
        isCurrentMonth
      }}>
      {children}
    </DateRangeContext.Provider>
  );
}

export function useDateRange() {
  return useContext(DateRangeContext);
}
